import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// Icons
import Handshake from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/Handshake';
import Lightbulb from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/Lightbulb';
import MagnifyingGlassWithDollarSign from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/MagnifyingGlassWithDollarSign';
import TwoPeopleTwoWordBubbles from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/TwoPeopleTwoWordBubbles';
// styles
import {
  ColStyledMobileContentContainer,
  ColStyledMobileIconContainer,
  ColStyledProductCard,
  SectionContainerStyled,
} from './styles';

export const ITEMS = [
  {
    id: 'working-with-an-advisor-will-understanding-product',
    icon: Handshake,
    contentAs: 'div',
    content: (
      <>
        A judgment&#45;free, <WidowBlock>pressure&#45;free environment.</WidowBlock>
      </>
    ),
  },
  {
    id: 'working-with-an-advisor-powers-attorney-understanding-product',
    icon: TwoPeopleTwoWordBubbles,
    contentAs: 'div',
    content: (
      <Typography
        component='span'
        block
        disableBottomPadding>
        Jargon&#45;free conversations
      </Typography>
    ),
  },
  {
    id: 'working-with-an-advisor-advanced-directives-understanding-product',
    icon: MagnifyingGlassWithDollarSign,
    contentAs: 'div',
    content: (
      <>
        Help seeing your financial blind spots and ways to account <WidowBlock>for them</WidowBlock>
      </>
    ),
  },
  {
    id: 'working-with-an-advisor-trusts-understanding-product',
    icon: Lightbulb,
    contentAs: 'div',
    content: (
      <Typography
        component='span'
        block
        disableBottomPadding>
        Answers to any questions you have, and the ones you never knew <WidowBlock>you had</WidowBlock>
      </Typography>
    ),
  },
];

export default () => {
  const theme = useContext(ThemeContext);
  const mediumDown = theme.mediumDown();
  const [isMobile, setIsMobile] = useState(mediumDown);

  useEffect(() => {
    if (mediumDown !== isMobile) {
      setIsMobile(mediumDown);
    }
  }, [mediumDown, isMobile]);

  return (
    <SectionContainerStyled
      id='working-with-an-advisor-understanding-product'
      backgroundVariant='lightB'
      moduleName='understanding-product-module'
      moduleVariation='A'>
      <Row align='center'>
        <Col
          medium={8}>
          <Typography
            align='center'
            component='h2'
            nextElement='typography'>
            Here&#39;s what makes our financial <WidowBlock>advisors different</WidowBlock>
          </Typography>
          <Typography
            align={isMobile ? 'left' : 'center'}
            nextElement='graphic'>
            Our advisors can show you the right financial steps to take you closer to the life you&#39;ve always wanted. Here&#39;s what you can expect when you work with one:
          </Typography>
        </Col>
      </Row>
      {isMobile
        ? (
          <Row align='center'>
            {ITEMS.map((item) => (
              <>
                <ColStyledMobileIconContainer
                  xsmall={3}
                  align='center'
                  id={`working-with-an-advisor-understanding-product-${item.id}`}
                  key={`understanding-product-col-${item.id}`}>
                  <item.icon
                    className='nmx-no-print'
                    height={55}
                    width={55}
                  />
                </ColStyledMobileIconContainer>
                <ColStyledMobileContentContainer
                  xsmall={9}
                  align='center'>
                  <Typography
                    align='left'
                    disableBottomPadding>
                    {item.content}
                  </Typography>
                </ColStyledMobileContentContainer>
              </>
            ),
            )}
          </Row>
        ) : (
          <Row align='center'>
            <Col
              medium={8}
              nested>
              <Row align='center'>
                {ITEMS.map((item) => (
                  <ColStyledProductCard
                    id={`working-with-an-advisor-understanding-product-${item.id}`}
                    key={`understanding-product-col-${item.id}`}
                    medium={6}>
                    <item.icon
                      className='nmx-no-print'
                      height={55}
                      width={55}
                    />
                    <Typography
                      disableBottomPadding>
                      {item.content}
                    </Typography>
                  </ColStyledProductCard>
                ))}
              </Row>
            </Col>
          </Row>
        )}
    </SectionContainerStyled>
  );
};
